import * as THREE from 'three';
import store from '../store';
class InteractControls extends THREE.EventDispatcher {
    camera; // 相机
    domElement; // 宿主dom
    // private objects:Object3D[]; // 场景中所有元素
    recursiveDetect; // 是否递归添加观察
    pointer; // 元素位置数组
    raycaster;
    intersects;
    currentObject;
    preObject;
    currentInfo;
    group;
    mouseDownPoint;
    mouseUpPoint;
    enabled;
    constructor(camera, domElement, group, recursiveDetect = false) {
        super();
        this.camera = camera;
        this.domElement = domElement;
        this.recursiveDetect = recursiveDetect;
        this.enabled = true;
        this.group = group;
        this.raycaster = new THREE.Raycaster();
        this.raycaster.camera = camera;
        if (recursiveDetect) {
            this.intersects = this.raycaster.intersectObject(group, true);
        }
        else {
            const list = [];
            group.traverse((mesh) => {
                if (mesh.isObserver) {
                    list.push(mesh);
                }
            });
            this.intersects = this.raycaster.intersectObjects(list, this.recursiveDetect);
        }
        // if (Array.isArray(group)) {
        //   this.intersects = this.raycaster.intersectObjects(group, this.recursiveDetect);
        // } else {
        //   this.intersects = this.raycaster.intersectObject(group, this.recursiveDetect);
        // }
        this.pointer = new THREE.Vector2();
        this.preObject = null;
        this.currentObject = null;
        this.EventHandler = this.EventHandler.bind(this);
        this.addListeners();
        store.interactControls = this;
    }
    update(group) {
        this.group = group;
        // this.updateGroup();
    }
    updateGroup() {
        if (this.recursiveDetect) {
            this.intersects = this.raycaster.intersectObject(this.group, true);
        }
        else {
            const list = [];
            this.group.traverse((mesh) => {
                if (mesh.isObserver) {
                    list.push(mesh);
                }
            });
            this.intersects = this.raycaster.intersectObjects(list, this.recursiveDetect);
        }
        if (store?.worldOctree) {
            const res = store.worldOctree.rayIntersect(this.raycaster.ray);
            if (res) {
                res.point = res.position;
                this.intersects.push(res);
            }
        }
    }
    addListeners() {
        this.domElement.addEventListener('pointerdown', this.EventHandler, false);
        this.domElement.addEventListener('pointerup', this.EventHandler, false);
        this.domElement.addEventListener('click', this.EventHandler, false);
        this.domElement.addEventListener('mousemove', this.EventHandler, false);
    }
    removeListeners() {
        this.domElement.removeEventListener('pointerdown', this.EventHandler, false);
        this.domElement.removeEventListener('pointerup', this.EventHandler, false);
        this.domElement.removeEventListener('click', this.EventHandler, false);
        this.domElement.removeEventListener('mousemove', this.EventHandler, false);
    }
    dispose() {
        this.removeListeners();
    }
    getWorldPosition(vertices) {
        this.raycaster.setFromCamera(vertices, this.camera);
        this.updateGroup();
        if (this.intersects.length > 0) {
            let maxzIndex = this.intersects[0].distance;
            let currentPoint = this.intersects[0].point;
            this.intersects.map((item) => {
                const distance = item.distance;
                if (distance <= maxzIndex) {
                    maxzIndex = distance;
                    currentPoint = item.point;
                }
            });
            return currentPoint;
        }
        return null;
    }
    getPosition(event) {
        this.updateGroup();
        this.getPoints(event);
        if (this.intersects.length > 0) {
            let maxzIndex = this.intersects[0].distance;
            let currentPoint = this.intersects[0].point;
            this.intersects.map((item) => {
                const distance = item.distance;
                if (distance <= maxzIndex) {
                    maxzIndex = distance;
                    currentPoint = item.point;
                }
            });
            return currentPoint;
        }
        return null;
    }
    EventHandler(event) {
        if (this.enabled === false)
            return;
        event.preventDefault();
        const type = event.type;
        this.getPoints(event);
        // （原则：distance最小的或者在数组最后的，说明是最前面的元素）
        if (this.intersects.length > 0) {
            const depthTestFalseList = [];
            this.intersects.forEach((intersect) => {
                if (intersect?.object?.material?.depthTest === false)
                    depthTestFalseList.push(intersect);
            });
            let maxzIndex = this.intersects[0].distance;
            let currentObject = this.intersects[0].object;
            let currentInfo = this.intersects[0];
            let targetObject, targetObjectInfo;
            if (depthTestFalseList.length > 0) {
                depthTestFalseList.map((item) => {
                    const object = item.object;
                    const distance = item.distance;
                    if (distance <= maxzIndex) {
                        currentObject = object;
                        maxzIndex = distance;
                        currentInfo = item;
                        targetObject = item.object || targetObject;
                        targetObjectInfo = item.object ? item : targetObjectInfo;
                    }
                });
            }
            else {
                this.intersects.map((item) => {
                    const distance = item.distance;
                    if (distance <= maxzIndex) {
                        currentObject = item;
                        maxzIndex = distance;
                        currentInfo = item;
                        targetObject = item.object || targetObject;
                        targetObjectInfo = item.object ? item : targetObjectInfo;
                    }
                });
            }
            this.currentInfo = targetObjectInfo || currentInfo;
            this.preObject = this.currentObject;
            this.currentObject = targetObject || currentObject;
        }
        else {
            this.currentInfo = {};
            this.preObject = this.currentObject;
            this.currentObject = null;
        }
        switch (type) {
            case 'pointerdown':
                this.mouseDownPoint = {
                    x: event.clientX,
                    y: event.clientY,
                };
                return this.onMouseDown(event);
            case 'pointerup':
                this.mouseUpPoint = {
                    x: event.clientX,
                    y: event.clientY,
                };
                return this.onMouseUp(event);
            case 'click':
                if (this.mouseDownPoint?.x === this.mouseUpPoint?.x && this.mouseDownPoint?.y === this.mouseUpPoint?.y) {
                    return this.onClick(event);
                }
                return;
            case 'mousemove':
                return this.onMouseMove(event);
            default:
                return false;
        }
    }
    onMouseDown(event) {
        // only fired when left mouse
        if (event.button === THREE.MOUSE.LEFT) {
            const position = this.getEventWorldPosition(event, this.domElement, this.camera);
            this.dispatchEvent({
                type: 'mousedown',
                mapTarget: this.currentObject,
                worldPosition: this.currentInfo.point,
                mapTargets: this.intersects,
                mapPosition: position,
            });
        }
    }
    onMouseUp(event) {
        // only fired when left mouse
        if (event.button === THREE.MOUSE.LEFT) {
            const position = this.getEventWorldPosition(event, this.domElement, this.camera);
            this.dispatchEvent({
                type: 'mouseup',
                mapTarget: this.currentObject,
                worldPosition: this.currentInfo.point,
                mapTargets: this.intersects,
                mapPosition: position,
            });
        }
        if (this.preObject && !this.currentObject) {
            // 处理鼠标不动，但是地图角度发生变化的情况
            this.dispatchEvent({ type: 'mouseleave', mapTarget: this.preObject });
        }
    }
    onClick(event) {
        // only fired when left mouse
        if (event.button === THREE.MOUSE.LEFT) {
            const position = this.getEventWorldPosition(event, this.domElement, this.camera);
            this.dispatchEvent({
                type: 'click',
                mapTarget: this.currentObject,
                worldPosition: this.currentInfo.point,
                mapTargets: this.intersects,
                mapPosition: position,
            });
        }
    }
    onMouseMove(event) {
        if (this.preObject || this.currentObject) {
            if (!this.preObject && this.currentObject) {
                this.dispatchEvent({ type: 'mouseenter', mapTarget: this.currentObject, mapTargets: this.intersects });
            }
            else if (this.preObject && this.currentObject) {
                if (this.preObject !== this.currentObject) {
                    this.dispatchEvent({ type: 'mouseleave', mapTarget: this.preObject, mapTargets: this.intersects });
                    this.dispatchEvent({ type: 'mouseenter', mapTarget: this.currentObject, mapTargets: this.intersects });
                }
                else {
                    // this.dispatchEvent({ type: 'mouseenter', mapTarget: this.currentObject });
                }
            }
            else if (this.preObject && !this.currentObject) {
                this.dispatchEvent({ type: 'mouseleave', mapTarget: this.preObject, mapTargets: this.intersects });
            }
        }
        const position = this.getEventWorldPosition(event, this.domElement, this.camera);
        this.dispatchEvent({
            type: 'mousemove',
            mapTarget: this.currentObject,
            worldPosition: this.currentInfo.point,
            mapTargets: this.intersects,
            mapPosition: position,
        });
    }
    getPoints(event) {
        // 将鼠标位置归一化为设备坐标。x 和 y 方向的取值范围是 (-1 to +1)
        if (!this.domElement)
            return;
        const rect = this.domElement.getBoundingClientRect();
        // Standard x and y in standard coordinate, range from [-1, 1]
        const x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        const y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
        if (this.pointer.x === x && this.pointer.y === y)
            return;
        this.pointer.x = x;
        this.pointer.y = y;
        // const vector = new THREE.Vector3(this.pointer.x, this.pointer.y, 1); // 标准设备坐标
        this.raycaster.setFromCamera(this.pointer, this.camera);
        // 标准设备坐标转世界坐标
        // const worldVector = vector.unproject(this.camera);
        // // 射线投射方向单位向量(worldVector坐标减相机位置坐标)
        // const ray = worldVector.sub(this.camera.position).normalize();
        // // 创建射线投射器对象
        // this.raycaster = new THREE.Raycaster(this.camera.position, ray);
        this.updateGroup();
        // 返回射线选中的对象 第二个参数如果不填 默认是false
        // this.intersects = rayCaster.intersectObjects(objects, true);
    }
    getEventWorldPosition(event, domElement, camera) {
        const rect = domElement.getBoundingClientRect();
        // Standard x and y in standard coordinate, range from [-1, 1]
        const standardX = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        const standardY = -((event.clientY - rect.top) / rect.height) * 2 + 1;
        // Get identity vector from camera to target point
        const vec = new THREE.Vector3().set(standardX, standardY, 0.5);
        vec.unproject(camera);
        vec.sub(camera.position).normalize();
        // Get vector from camera to XY plane
        vec.multiplyScalar(-camera.position.z / vec.z);
        // Get intersect on XY plane
        const pos = new THREE.Vector3().copy(camera.position).add(vec);
        return { x: pos.x, y: pos.y };
    }
}
export default InteractControls;
